import { SingleSubpointTranslationHelper } from './single-subpoint-translation-helper';

export class AddedSubpointTranslationHelper extends SingleSubpointTranslationHelper {
  protected override method = 'add_subpoint';
}
